export default {
  tabs: {
    legalTender: "Fiat Summary",
    virtualCoin: "Crypto Summary",
    transactionDetails: "Transaction Details",
  },
  download: {
    filename: "Data Details",
  },
};
